import React from 'react';
import styled from 'styled-components';
import LiveIcon from '../assets/live-icon.gif';
import { stage, setup } from '../config';

const { currentStage } = setup;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

const Header = styled.h2`
  margin-right: 8px;
`;

const ImageWrapper = styled.div`
  width: 68px;
  display: flex;
  align-items: center;
  > img {
    width: 100%;
  }
`;

const LiveComponent = () => {
  if(currentStage === stage.live) {
    return (
      <ImageWrapper>
        <img src={LiveIcon} alt="live icon" />
      </ImageWrapper>
    );
  }
  return null;
}

const LiveHeader = ({
  text,
}) => {
  return (
    <HeaderContainer>
      <Header>{text}</Header>
      <LiveComponent />
    </HeaderContainer>
  )
}

export {
  LiveComponent,
};

export default LiveHeader;
